import React from "react";
import { motion } from "framer-motion";

const Loading = ({
  message = "Loading...",
  size = "medium",
  fullScreen = false,
  background = "transparent",
}) => {
  // Size configurations
  const sizeConfig = {
    small: {
      iconSize: "32px",
      padding: "32px 16px",
      fontSize: "14px",
      minHeight: "150px",
    },
    medium: {
      iconSize: "48px",
      padding: "64px 32px",
      fontSize: "16px",
      minHeight: "300px",
    },
    large: {
      iconSize: "64px",
      padding: "80px 40px",
      fontSize: "18px",
      minHeight: "400px",
    },
  };

  const config = sizeConfig[size] || sizeConfig.medium;

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: config.padding,
    textAlign: "center",
    color: "#4285f4",
    fontSize: config.fontSize,
    fontWeight: "500",
    gap: "16px",
    minHeight: config.minHeight,
    background: background === "card" ? "#f8fafc" : background,
    borderRadius: background === "card" ? "12px" : "0",
    border: background === "card" ? "1px solid #e2e8f0" : "none",
    boxShadow: background === "card" ? "0 2px 8px rgba(0, 0, 0, 0.05)" : "none",
    width: fullScreen ? "100vw" : "100%",
    height: fullScreen ? "100vh" : "auto",
    position: fullScreen ? "fixed" : "relative",
    top: fullScreen ? 0 : "auto",
    left: fullScreen ? 0 : "auto",
    zIndex: fullScreen ? 9999 : "auto",
  };

  const iconStyle = {
    fontSize: config.iconSize,
    color: "#4285f4",
  };

  return (
    <motion.div
      style={containerStyle}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      <motion.span
        className="material-icons"
        style={iconStyle}
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
      >
        sync
      </motion.span>
      {message}
    </motion.div>
  );
};

export default Loading;
